import React from "react";
import Slider from "react-slick";

const CustomSlider = ({
  data = [],
  numbers = 3,
  renderCard = () => {},
  NextArrow = false,
  PrevArrow = false,
  isReserve = false,
}) => {
  const renderSlidesToShow = () => {
    if (data.length > numbers) {
      return numbers;
    } else {
      return data.length;
    }
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: renderSlidesToShow(),
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,

    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: renderSlidesToShow(),
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: isReserve ? 3 : 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: isReserve ? 2 : 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  if (isReserve) {
    // settings.nextArrow = <CustomArrow />;
    // settings.prevArrow = <CustomArrow />;
  }

  return (
    <Slider {...settings}>
      {data.map((card, count) => {
        return renderCard(card, count);
      })}
    </Slider>
  );
};
export default CustomSlider;

function CustomArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        // display: "block",
        background: "black",
        borderRadius: "50%",
        color: "red",
      }}
      onClick={onClick}
    />
  );
}
